import { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';

import Dropdown from "./Dropdown";

const MenuItems = ({ items, depthLevel, refresh }) => {
  const [dropdown, setDropdown] = useState(false);

  let ref = useRef();

  useEffect(() => {
    const handler = (event) => {
      if (dropdown && ref.current && !ref.current.contains(event.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [dropdown]);

  const onMouseEnter = () => {
    window.innerWidth > 840 && setDropdown(true);
  };

  const onMouseLeave = () => {
    window.innerWidth > 840 && setDropdown(false);
  };
  return (
    <li
      className="menu-items"
      style={{fontSize: (window.innerWidth>600?"14px":String(14*window.innerWidth/600)+"px")}}
      ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {items.submenu ? (
        <>
          <button
            type="button"
            aria-haspopup="menu"
            aria-expanded={dropdown ? "true" : "false"}
            onClick={() => setDropdown(prev => !prev)}
          >
            {items.title}{" "}
            {depthLevel > 0 ? "»" : "▾"}
          </button>
          <Dropdown
            depthLevel={depthLevel}
            submenus={items.submenu}
            dropdown={dropdown}
          />
        </>
      ) : (
        <Link to={items.link}>{items.title}</Link>//onClick={()=>refresh()}
      )}
    </li>
  );
};
export default MenuItems;